/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureSecurityGraph extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureSecurityGraph");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureSecurityGraph.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureSecurityGraph>): ServiceAccountNativeDetailsForAzureSecurityGraph {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureSecurityGraph(), model);
        ServiceAccountNativeDetailsForAzureSecurityGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureSecurityGraph>): ServiceAccountNativeDetailsForAzureSecurityGraph {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureSecurityGraph.newInstance(<ServiceAccountNativeDetailsForAzureSecurityGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureSecurityGraph) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureSecurityGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureSecurityGraph): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureSecurityGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Azure Cloud Type. This is a required field.
     */
    cloud_type: models.AzureCloudType;

}
